import { ExerciseItem } from "types/game";

export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

export const shuffleArrayExercise = (
  array: any[],
  type,
  isRequireShuffle?: boolean
): ExerciseItem[] => {
  const localExercises = localStorage.getItem(type);
  let localExercisesParse = null;
  let arrBoof = [];
  if (localExercises) {
    localExercisesParse = JSON.parse(localExercises);
  }
  if (localExercisesParse?.length && !isRequireShuffle) {
    arrBoof = [...localExercisesParse];
  } else {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }

    const arrBoof2 = array.map((val, index) => {
      return {
        Data: {
          ...val.Data,
          index: index + 1
        }
      };
    });
    arrBoof = arrBoof2.sort(function (a, b) {
      return a?.Data?.index - b?.Data?.index;
    });

    localStorage.setItem(type, JSON.stringify(arrBoof));
  }
  return arrBoof;
};
